// extracted by mini-css-extract-plugin
export default {"diploma":"Diploma_diploma__kQQMY","container":"Diploma_container__DOviX"};